import * as z from "zod";

/**
 * Read-only check used by the create-partner modal to give admins
 * inline feedback as they type. Format / reserved / profanity rules
 * run client-side from `@redotech/redo-partners-core/partner-account/referral-code`;
 * this RPC narrowly answers "is the code already taken in the DB?".
 */
export const checkReferralCodeAvailable = {
  name: "checkReferralCodeAvailable" as const,
  input: z.object({ code: z.string().min(1).max(40) }),
  output: z.object({ available: z.boolean() }),
};
